export default "__VITE_ASSET__a7a5c7ad__"